var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#fi_check-circle_svg__a)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M45.833 23.083V25A20.833 20.833 0 1 1 33.48 5.958"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#fi_check-circle_svg__b)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M45.833 8.333 25 29.187l-6.25-6.25"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fi_check-circle_svg__a",
  x1: 45.833,
  x2: 4.167,
  y1: 24.988,
  y2: 24.988,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00CBA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#09F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fi_check-circle_svg__b",
  x1: 45.833,
  x2: 18.75,
  y1: 18.76,
  y2: 18.76,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00CBA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#09F"
})))));
export default SvgFiCheckCircle;